<div class="modal-mg">
  <div class="modal-mg-dialog modal-mg-dialog-centered">
    <div class="modal-mg-content">
      <div class="modal-mg-header">
        <h5 class="modal-mg-title" id="exampleModalLongTitle">
          {{
            this.data.city && this.data.city.length > 0
              ? dataTranslateRegister?.titleEdit
              : dataTranslateRegister?.title
          }}
        </h5>
        <div class="btn-close-mg" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </div>
      </div>
      <div class="modal-mg-body">
        <div class="form-group-mg">
          <label class="mg-label">
            <strong> {{ dataTranslateRegister?.addressSearch }} </strong>
          </label>
          <input
            #address
            [placeholder]="dataTranslateRegister?.address"
            [value]="formAddress.address"
            (input)="onInputChange($event, 'address')"
          />
        </div>

        <div class="form-group-mg">
          <label class="mg-label">
            <strong> {{ dataTranslateRegister?.titleReferences }} </strong>
          </label>
          <input
            [placeholder]="dataTranslateRegister?.references"
            [value]="formAddress.references"
            (input)="onInputChange($event, 'references')"
          />
        </div>

        <div
          #mapContainer
          id="map"
          style="
            position: relative;
            height: 200px;
            width: 100%;
            border-radius: 8px;
            margin-bottom: 1rem;
          "
        ></div>
        <div class="row-mg">
          <div class="form-group-mg">
            <label class="mg-label">
              <strong> {{ dataTranslateRegister?.country }} </strong>
            </label>
            <input
              type="text"
              id="country"
              [value]="formAddress.country"
              (input)="onInputChange($event, 'country')"
            />
          </div>
          <div class="form-group-mg">
            <label class="mg-label">
              <strong> {{ dataTranslateRegister?.state }} </strong>
            </label>
            <input
              type="text"
              id="state"
              [value]="formAddress.state"
              (input)="onInputChange($event, 'state')"
            />
          </div>
        </div>
        <div class="row-mg">
          <div class="form-group-mg">
            <label class="mg-label">
              <strong> {{ dataTranslateRegister?.city }} </strong>
            </label>
            <input
              type="text"
              id="city"
              [value]="formAddress.city"
              (input)="onInputChange($event, 'city')"
            />
          </div>
          <div class="form-group-mg">
            <label class="mg-label">
              <strong> {{ dataTranslateRegister?.zipCode }} </strong>
            </label>
            <input
              type="text"
              id="zipCode"
              [value]="formAddress.zipCode"
              (input)="onInputChange($event, 'zipCode')"
            />
          </div>
        </div>
      </div>
      <div class="modal-mg-footer">
        <button type="button" (click)="addForm()">
          {{
            this.data.city && this.data.city.length > 0
              ? dataTranslateRegister?.edit
              : dataTranslateRegister?.add
          }}
        </button>
      </div>
    </div>
  </div>
</div>
